var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcX = function SvgIcX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ic_x_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18.043,
    cy: 18.007,
    fill: "#000",
    r: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.716 17.298 26.425 9.5h-1.59l-5.825 6.77-4.652-6.77H8.992l7.035 10.239-7.035 8.177h1.59l6.151-7.15 4.913 7.15h5.366l-7.296-10.618Zm-2.177 2.53-.713-1.019-5.671-8.112h2.442l4.577 6.547.712 1.02 5.95 8.51h-2.442l-4.855-6.945Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ic_x_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(-.004)",
    d: "M0 0h35.999v36H0z"
  })))));
};
export default SvgIcX;